import React from "react";
import { Link } from "react-router-dom";
import logoColor from "../assets/clearbadge-logo-color.png";
import { VerificationIcon } from "../assets/icons/icons";

function LinkedInIcon(props) {
  return (
    <svg
      aria-hidden="true"
      fill="currentColor"
      viewBox="0 0 24 24"
      {...props}
    >
      <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
    </svg>
  );
}

export default function LandingFooter({ className = "" }) {
  const footerClassName = ["landing-footer", className].filter(Boolean).join(" ");
  return (
    <footer className={footerClassName}>
      <div className="landing-container footer-top-row">
        <div className="footer-brand-block">
          <img src={logoColor} alt="ClearBadge\u2122" className="footer-logo" />
          <p className="muted footer-brand-copy">
            Trust through transparency. Verify professional licenses instantly and make informed decisions.
          </p>
          <div className="footer-badge">
            <VerificationIcon className="footer-badge-icon" /> Trusted verification platform
          </div>
        </div>
        <nav className="footer-links-inline" aria-label="Footer navigation">
          <Link to="/about">About</Link>
          <Link to="/affiliate">Affiliate Program (25%)</Link>
          <Link to="/privacy-policy">Privacy Policy</Link>
          <Link to="/terms-of-service">Terms of Service</Link>
          <Link to="/delete-account">Delete Account</Link>
          <a href="/verbal-consent-sms">Verbal Consent SMS</a>
          <a href="/smstos">SMS Terms and Privacy</a>
          <a href="mailto:support@clearbadge.org">support@clearbadge.org</a>
          <a href="tel:18008388439">1-800-838-8439</a>
        </nav>
        <div className="footer-social-col" aria-label="Social links">
          <a
            href="https://www.linkedin.com/company/clearbadge/"
            target="_blank"
            rel="noopener noreferrer"
            className="footer-social-link"
            aria-label="ClearBadge\u2122 on LinkedIn"
          >
            <LinkedInIcon className="footer-social-icon" aria-hidden="true" />
          </a>
        </div>
      </div>
      <div className="landing-container footer-bottom">
        <span className="muted">
          {"\u00a9"} {new Date().getFullYear()} ClearBadge<sup>&trade;</sup>. All rights reserved. Built with trust and transparency.
        </span>
        <p className="unverified-disclaimer footer-advice-disclaimer" role="note" aria-label="Advice disclaimer">
          ClearBadge<sup>&trade;</sup> does not provide insurance, legal, or financial advice. Users are responsible for evaluating professionals and
          services independently.
        </p>
      </div>
    </footer>
  );
}


